import React, { useState, useRef, useEffect } from "react";
import { connect } from "react-redux";
import "./AnimatedNumberInput.css";

const AnimatedNumberInput = ({
  value,
  onChange,
  name,
  autoFocus,
  isDarktheme,
  ...props
}) => {
  const [animatingIndex, setAnimatingIndex] = useState(-1);
  const inputRef = useRef(null);
  const previousValueRef = useRef(value);

  useEffect(() => {
    // Detect when a new character is added
    if (value.length > previousValueRef.current.length) {
      setAnimatingIndex(value.length - 1);
      // Reset animation after it completes
      const timer = setTimeout(() => {
        setAnimatingIndex(-1);
      }, 500); // Match animation duration
      return () => clearTimeout(timer);
    }
    previousValueRef.current = value;
  }, [value]);

  const handleChange = (e) => {
    // Only allow numbers
    const newValue = e.target.value.replace(/[^0-9]/g, "");
    if (newValue.length <= 10) {
      const syntheticEvent = {
        ...e,
        target: {
          ...e.target,
          value: newValue,
          name: name,
        },
      };
      onChange(syntheticEvent);
      
      // Dispatch custom event to notify RightSideBar of phone number change
      window.dispatchEvent(new CustomEvent('phoneNumberInputChange', {
        detail: { phoneNumber: newValue }
      }));
    }
  };

  return (
    <div className="animated-number-input-wrapper">
      <input
        ref={inputRef}
        type="text"
        inputMode="numeric"
        pattern="[0-9]*"
        className={`animated-number-input ${
          isDarktheme ? "dark-theme" : ""
        } form-control form-control-lg rounded input-field`}
        value={value}
        onChange={handleChange}
        name={name}
        autoFocus={autoFocus}
        maxLength={10}
        {...props}
      />
      <div className="animated-overlay" aria-hidden="true">
        {value.split("").map((char, index) => (
          <span
            key={`${index}-${char}`}
            className={`animated-char ${
              index === animatingIndex ? "pop-in" : ""
            }`}
          >
            {char}
          </span>
        ))}
      </div>
    </div>
  );
};

const mapStateToProps = ({ darkTheme: { isDarktheme } }) => ({
  isDarktheme,
});

export default connect(mapStateToProps, null)(AnimatedNumberInput);

